export default "__VITE_ASSET__dd3b85a4__"